import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchArrivalRatesPerService from "../../../components/branches/reports/daily/BranchArrivalRatesPerService";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchArrivalRatesPerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="BranchesArrivalRatesPerService"
    normalizeData={asArray}
    title={`${reportIndex}. Arrival Rates Per Service`}
  >
    {({ data, renderConfig }) => (
      <BranchArrivalRatesPerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchArrivalRatesPerService;
